import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  getFullApiUrl,
  getFullCdnUrl,
  ITEMS_PER_PAGE,
  podcastId,
} from "../../../config";
import { extractVol, formatDateSlash } from "../../../utils";
import { EpisodeCard } from "../../../designSystem";
import Pager from "../../ui/Pager";
import { ErrorPage } from "../../ErrorPage";
import { LoadingPage } from "../../LoadingPage";

/** 视频封面地址（与 iOS/Android 客户端一致）：cdn/video/{podcastId}/{dir}/thumbnail.jpg */
const videoThumbnailUrl = (video) =>
  video.VideoDirectory
    ? getFullCdnUrl(
        `cdn/video/${video.PodcastID}/${video.VideoDirectory}/thumbnail.jpg`
      )
    : null;

const VideoBlogsPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideoBlogs = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          getFullApiUrl("/api/v1/subscribe/get_videos"),
          {
            params: {
              podcast: podcastId,
              start: (page - 1) * ITEMS_PER_PAGE,
              end: page * ITEMS_PER_PAGE,
            },
          }
        );
        setVideos(response.data.videos);
        setTotalPages(
          Math.ceil(response.data.number_of_episodes / ITEMS_PER_PAGE)
        );
        setLoading(false);
      } catch (err) {
        setError("视频列表加载失败，请稍后重试。");
        setLoading(false);
      }
    };

    fetchVideoBlogs();
  }, [page]);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  const openVideo = (video) => {
    navigate(`/video/${video.ID}`, { state: { video } });
  };

  return (
    <div className="lt-main">
      <div className="lt-pagehead">
        <h1>视频</h1>
        <p>《边角聊》的视频节目。</p>
      </div>
      <div className="lt-cardgrid">
        {videos.map((video) => (
          <EpisodeCard
            key={video.ID}
            className="bjl-epcard--wide"
            episode={{
              id: video.ID,
              vol: extractVol(video.Title),
              title: video.Title,
              date: formatDateSlash(video.PublishedAt),
              memberOnly: !!video.IsPaid,
              cover:
                videoThumbnailUrl(video) ||
                `${process.env.PUBLIC_URL}/logo512.png`,
              coverFallback: `${process.env.PUBLIC_URL}/logo512.png`,
            }}
            onOpen={() => openVideo(video)}
            onPlay={() => openVideo(video)}
          />
        ))}
      </div>
      {videos.length === 0 ? (
        <div className="lt-center-state">
          <p>暂时还没有视频内容。</p>
        </div>
      ) : null}
      <Pager page={page} totalPages={totalPages} onChange={setPage} />
    </div>
  );
};

export default VideoBlogsPage;
